import { loadScriptAsync, isValidURL, isValidEmail, getCurrentTimestamp } from "../libs/util";

export default function () {
	function isEmpty(str) {
		return !str || 0 === str.length;
	}

	return {
		loading: 0,
		formTitle: "",
		successMessage: "",
		multipleForms: 0,
		mktoUser: window.Alpine.$persist(""),
		referrer: document.referrer,

		async init() {
			console.log("--- MARKETO FORM MODULE ---");

			// Try to load the Forms2 library
			try {
				if (typeof window.MktoForms2 === "undefined") {
					await loadScriptAsync("https://info.ai.baesystems.com/js/forms2/js/forms2.min.js", "forms2");
				}
			} catch (error) {
				console.warn("Failed to load Forms2:", error);
			}
			this.$dispatch("scripts-loaded", true);
		},

		_removeCSS() {
			try {
				window.MktoForms2.whenReady((mktoForm) => {
					try {
						const $form = mktoForm.getFormElem();
						$form.removeAttr("style");
						$form.find("style").remove();
						const children = $form.find(
							".mktoButtonWrap,.mktoFieldDescriptor,.mktoLabel,.mktoField,.mktoHtmlText,.mktoFormCol,.mktoCheckboxList,.mktoOffset"
						);
						children.each((i, el) => el.removeAttribute("style"));
					} catch (error) {
						console.warn(error);
					}
				});
			} catch (error) {
				console.warn(error);
			}
		},

		async loadGatedForm($event) {
			try {
				const { restBase, munchkinKey } = window.Alpine.store("app");
				this.loading = 1;
				const { formId, resourceID, resourceURL, resourceTitle, successMessage } = $event.detail;
				const { formWrapper } = this.$refs;
				const top = this.$el.offsetTop + 125;
				const form = document.createElement("form");
				form.id = `mktoForm_${formId}`;
				form.className = "space-y-4";
				formWrapper.replaceChildren();
				formWrapper.appendChild(form);
				this.formTitle = `Download ${resourceTitle}`;

				if (typeof window.MktoForms2 !== "undefined" && formId) {
					const formObject = window.MktoForms2.getForm(formId);
					if (!!formObject) {
						this.loading = 2;
						formObject.render();
					} else {
						if (munchkinKey) {
							window.MktoForms2.loadForm("https://info.ai.baesystems.com", munchkinKey, formId, (mktoForm) => {
								if (!mktoForm) return;

								if (this.referrer && window.Munchkin) {
									window.Munchkin.munchkinFunction("visitWebPage", {
										url: this.referrer,
									});
								}

								this.loading = 2;
								// find the first element
								const $form = mktoForm.getFormElem();
								const fieldIds = Object.keys(mktoForm.getValues()).filter((field) => field !== "formid" && field !== "munchkinId");
								const fields = fieldIds.join("&fields=");
								const firstElm = $form.find(`input:not([disabled]):not([type="hidden"])`).first();
								setTimeout(() => {
									if (firstElm.length > 0) {
										firstElm[0].focus();
									}
								}, 0);
								// Prepoulate the hidden fields
								mktoForm.vals({
									resourceID: resourceID || "",
									resourceURL: resourceURL ? window.origin + resourceURL : "",
									resourceCapture: resourceTitle || "",
									resourceTitle: resourceTitle || "",
									resourcecapturetemp: resourceTitle || "",
									resourceCaptureTimeStamp: getCurrentTimestamp(),
								});

								mktoForm.addHiddenFields({
									referrerURL: this.referrer,
									Current_Page_URL: window.location.href,
								});

								$form.find(".mktoEmailField").blur(async (e) => await this.preFillFormByEmail(e.currentTarget.value, restBase, fields));

								if (this.mktoUser != "" && isValidEmail(this.mktoUser)) {
									this.preFillFormByEmail(this.mktoUser, restBase, fields);
								}

								mktoForm.onSuccess((values) => {
									try {
										this.mktoUser = Object.hasOwn(values, "Email") ? values.Email : "";
										this.successMessage =
											successMessage ||
											`Thank you for requesting to access <b>${resourceTitle}</b>.<br>You will soon receive a link, sent by email, to access the document.<br>Thank you for your interest in BAE Systems`;
										mktoForm.getFormElem().hide();
										setTimeout(() => {
											this.successMessage = "";
											this.loading = 0;
											window.scrollTo({
												top: top,
												behavior: "smooth",
											});
										}, 60000); // one min before reseting the content.

										// GTM TRACKING
										window.dataLayer.push({
											event: "marketoSubmit",
											"form-id": formId,
										});
									} catch (error) {
										console.warn(error);
									}
									return false;
								});
							});
						} else {
							console.warn("munchkinKey is not provided.");
						}
					}
					this._removeCSS();
					setTimeout(() => {
						window.scrollTo({
							top: top,
							behavior: "smooth",
						});
					}, 150);
				} else {
					console.warn("MktoForms2 not loaded.");
					this.loading = 0;
				}
			} catch (error) {
				this.loading = 0;
				console.warn(error);
			}
		},

		loadMarketoForm(e, formId) {
			try {
				const { restBase, munchkinKey } = window.Alpine.store("app");
				const formExists = document.querySelectorAll(`#mktoForm_${formId}`);
				this.multipleForms = formExists.length;
				this.loading = 1;
				this.successMessage = "";

				if (typeof window.MktoForms2 !== "undefined" && formId) {
					const formObject = window.MktoForms2.getForm(formId);
					if (!!formObject) {
						this.loading = 2;
						formObject.render();
					} else {
						if (munchkinKey) {
							window.MktoForms2.loadForm("https://info.ai.baesystems.com", munchkinKey, formId, (mktoForm) => {
								if (!mktoForm) return;

								if (this.referrer && window.Munchkin) {
									window.Munchkin.munchkinFunction("visitWebPage", {
										url: this.referrer,
									});
								}

								this.loading = 2;
								const $form = mktoForm.getFormElem();
								const fieldIds = Object.keys(mktoForm.getValues()).filter((field) => field !== "formid" && field !== "munchkinId");
								const fields = fieldIds.join("&fields=");
								$form.find(".mktoEmailField").blur(async (e) => this.preFillFormByEmail(e.currentTarget.value, restBase, fields));

								if (this.mktoUser != "" && isValidEmail(this.mktoUser)) {
									this.preFillFormByEmail(this.mktoUser, restBase, fields);
								}

								mktoForm.vals({
									resourceCaptureTimeStamp: getCurrentTimestamp(),
								});

								mktoForm.addHiddenFields({
									referrerURL: this.referrer,
									Current_Page_URL: window.location.href,
								});

								mktoForm.onSuccess((values, followUpUrl) => {
									// TEST THE FOLLOW UP URL
									if (isValidURL(followUpUrl)) {
										const newFollowUpUrl = new URL(followUpUrl);
										if (newFollowUpUrl.pathname !== window.location.pathname) {
											window.location.href = newFollowUpUrl;
										}

										this.successMessage = this.$el.dataset.successMessage || "Thank you for your subscription.";
										mktoForm.getFormElem().hide();
									}

									window.dataLayer.push({
										event: "marketoSubmit",
										"form-id": formId,
									});
									return false;
								});
							});
						} else {
							console.warn("munchkinKey is not provided.");
						}
					}
					this._removeCSS();
				} else {
					console.warn("MktoForms2 not loaded.");
					this.loading = 0;
				}
			} catch (error) {
				this.loading = 0;
				console.warn(error);
			}
		},

		// Marketo
		async preFillFormByEmail(email, restBase, fields) {
			try {
				// TEST IF IT'S A VALID EMAIL
				if (isValidEmail(email) === false) {
					return;
				}
				const { formWrapper } = this.$refs;
				const leadEndpoint = `${restBase}/marketing-automation/v1/leads`;
				const url = leadEndpoint.concat(`?definitionName=marketo&filterType=email&filterValues=${email}&fields=${fields}&checkFormPrefilling=true`);
				const response = await fetch(url);
				const pageResponse = await response.json();
				if (pageResponse) {
					let data = pageResponse.values;
					const keys = Object.keys(data).forEach((key) => {
						let fieldValue = data[key];
						const inputElement = [...formWrapper.querySelectorAll("input")].find(
							(input) => input.name.toLowerCase() === key.toLowerCase() || input.id.toLowerCase() === key.toLowerCase()
						);

						// populate the fields if they are not populated already
						if (inputElement) {
							if (isEmpty(inputElement.value) || inputElement.type === "checkbox" || inputElement.type === "select-one") {
								if (inputElement.type === "select-multiple" || (inputElement.type === "select" && inputElement.multiple)) {
									for (let i = 0; i < inputElement.options.length; i++) {
										inputElement.options[i].selected = fieldValue.indexOf(inputElement.options[i].value) >= 0;
									}
								} else {
									inputElement.value = fieldValue;
								}

								inputElement.dispatchEvent(new Event("change"));
							}

							// For radio and checkbox
							if (inputElement.tagName === "FIELDSET") {
								let inputs = inputElement.getElementsByTagName("input");
								for (let i = 0; i < inputs.length; i++) {
									if (inputs[i].type === "checkbox" || inputs[i].type === "radio") {
										inputs[i].checked = inputs[i].value == fieldValue;
										inputs[i].dispatchEvent(new Event("change"));
									}
								}
							}
						}
					});
				}
				return;
			} catch (error) {
				console.warn(error);
			}
		},
	};
}
